import Big from 'big.js';
import Masonry from 'masonry-layout';
import { GetChildPrice, GetOptionPrice, GetPrice, GetPrices, GetSizes, GetTypes, Size } from 'smg/customer-api/lineitems';
import { Anchorize, FromString } from 'smg/html';
import { G } from 'smg/querystring';
import { Clone } from 'smg/template';
import { DollarFormat } from 'smg/util';
import { UUID } from 'smg/uuid';
import { CustomQtyBtnInit } from '../components/buttons';
import { RadioBorderListener } from '../components/forms/form-control';
import { GetMoldFee } from '../moldfees';

let currProduct: string;
let currType: string;
let currSubType: string;
let lineItemTypeSize: Partial<Size>;

let $addlRowCostItems: HTMLElement[] = [];
export let GalleryMasonry: Masonry | null = null;

if (document.body.id === 'pricing') {
    const $pricingContainer = document.querySelector('#pricing-products-types-container') as HTMLElement;

    // Init border listener
    RadioBorderListener();

    // Scoped Funcs
    const dispatchChangeEventIfChecked = ($productTypeRadios: HTMLInputElement[]) => {
        for (const $productTypeRadio of $productTypeRadios) {
            if ($productTypeRadio.checked) {
                $productTypeRadio.dispatchEvent(new Event('change'));
            }
        }
    };

    const hasListeners: Element[] = [];
    const checkAddListeners = ($productTypeRadios: HTMLInputElement[], $productTab: HTMLElement) => {
        if (!hasListeners.includes($productTab)) {
            addRadioListeners($productTypeRadios);
            hasListeners.push($productTab);
        }
    };

    const createSizeElementsForProduct = ($productTypeRadios: HTMLInputElement[]) => {
        const type = currTypeInput($productTypeRadios);
        const product = type?.dataset.product;
        if (type && product) {
            void createSizeEls(currProduct, type.value || currType, currSubType, '', type.dataset.href ?? '').then(() => RadioBorderListener());
        }
    };

    // Page initialization
    const $productTypeRadios = getRadios();
    dispatchChangeEventIfChecked($productTypeRadios);
    const $productTabs = Array.from($pricingContainer.querySelectorAll<HTMLElement>('.nav-link.product-tab'));
    const activeTab = $productTabs.find($productTab => $productTab.classList.contains('active'));
    if (activeTab) {
        currType = currTypeInput($productTypeRadios)?.value || '';
        currProduct = currTypeInput($productTypeRadios)?.dataset.product || '';
        currSubType = currTypeInput($productTypeRadios)?.dataset.subtype || '';
        checkAddListeners($productTypeRadios, activeTab);
        createSizeElementsForProduct($productTypeRadios);
        aboutSection(currProduct, currType, currSubType);
        updatePricingChart(activeTab.id.replace('-tab', '').replaceAll('-', ' '), currTypeInput($productTypeRadios)?.value || '');
        gallerySection(currProduct, currType, currSubType);
    }

    for (const $productTab of $productTabs) {
        $productTab.addEventListener('shown.bs.tab', () => {
            currProduct = $productTab.id.replace('-tab', '');
            const $productTypeRadios = getRadios();
            checkAddListeners($productTypeRadios, $productTab);
            dispatchChangeEventIfChecked($productTypeRadios);
        });
    }

    const $pricingCalcTabPaneBtn = document.querySelector<HTMLElement>('#calculator-tab');
    const $pricingChartTabPaneBtn = document.querySelector<HTMLElement>('#chart-tab');
    const $pricingCalcTabPane = document.querySelector<HTMLElement>('#pricing-calculator-tab-pane');
    const $pricingChartTabPane = document.querySelector<HTMLElement>('#pricing-chart-tab-pane');

    if (G().Get('chart')) {
        $pricingCalcTabPaneBtn?.classList.remove('active', 'show');
        $pricingChartTabPaneBtn?.classList.add('active', 'show');
        $pricingCalcTabPane?.classList.remove('active', 'show');
        $pricingChartTabPane?.classList.add('active', 'show');
    }

    $pricingChartTabPaneBtn?.addEventListener('shown.bs.tab', () => {
        G().Set('chart', 'true');
    });
    $pricingCalcTabPaneBtn?.addEventListener('shown.bs.tab', () => {
        G().Delete('chart');
    });

    // const masonry = new Masonry('#short-gallery', {
    //     itemSelector: '.gallery-item',
    //     gutter: 24,
    // });

    // masonry.layout?.();
}

// Helpers

function getRadios(): HTMLInputElement[] {
    const $currTabPane = document.querySelector('.tab-pane.product-tab-pane.active') as HTMLElement;
    const $productTypeRadios = Array.from($currTabPane.querySelectorAll<HTMLInputElement>('.product-type-input'));
    return $productTypeRadios;
}

function addRadioListeners($productTypeRadios: HTMLInputElement[]) {
    for (const $productTypeRadio of $productTypeRadios) {
        $productTypeRadio.addEventListener('change', () => {
            currType = $productTypeRadio.value;
            const subType = $productTypeRadio.dataset.subtype ?? '';
            currSubType = subType;

            if ($productTypeRadio.dataset.pricingpage) {
                window.history.replaceState({}, '', $productTypeRadio.dataset.pricingpage);
            }
            const $productType = $productTypeRadio.value;
            const $product = $productTypeRadio.dataset.product;
            if ($product) {
                const $typeSizesContainer = document.querySelector('#type-sizes-container') as HTMLElement;
                const preSelectedSize = $typeSizesContainer.querySelector<HTMLInputElement>('input:checked')?.value;
                void createSizeEls($product, $productType, subType ?? '', preSelectedSize ?? '', $productTypeRadio.dataset.href ?? '').then(() => RadioBorderListener());
            }
            if ($product && $productType) {
                updatePricingChart($product, $productType);
                aboutSection($product, $productType, subType);
                gallerySection($product, $productType, subType);
            }
        });
    }
}

function currTypeInput($typeRadios: HTMLInputElement[]): HTMLInputElement | undefined {
    return $typeRadios.find($typeRadio => $typeRadio.checked);
}

async function createSizeEls(lineItem: string, type: string, subType: string, preSelectedSize: string, typePage: string) {
    const $sizesContainer = document.querySelector('#type-sizes-container') as HTMLElement;
    await GetSizes(lineItem, type).then(resp => {
        $sizesContainer.innerHTML = '';
        const sizeRadios = [];
        for (const size of resp) {
            if (size.quoteForm) {
                const uuid = UUID();
                const $radioEl = Clone(`.product-size-radio-template[data-product='${CSS.escape(lineItem)}'][data-type='${CSS.escape(subType || type)}']`).firstElementChild as HTMLLabelElement;
                const $productTypeImg = $radioEl.querySelector('.product-type-img') as HTMLImageElement;
                if (size.type && size.type === 'Square') {
                    const $squareImg = Clone('#usa-rush-pins-square') as HTMLImageElement;
                    $productTypeImg.closest('picture')?.replaceWith($squareImg);
                }
                const $inputEl = $radioEl.querySelector('input') as HTMLInputElement;
                const $sizeText = $radioEl.querySelector('h5') as HTMLElement;
                const $quarterImg = $radioEl.querySelector<HTMLImageElement>('.quarter-img');
                const scaleAvg = ((1 / size.height) + (1 / size.width)) / 2;
                if (lineItem === 'lanyards') {
                    $productTypeImg.height = $productTypeImg.height / scaleAvg;
                    $productTypeImg.width = $productTypeImg.width / scaleAvg;
                    $sizeText.style.marginTop = `${16 * scaleAvg} px`;
                    $productTypeImg.style.marginLeft = `${8 * scaleAvg} px`;
                } else {
                    if (size.height !== size.width) {
                        if (size.height > 1) {
                            $productTypeImg.height = $productTypeImg.height / (1 / size.height);
                        } else {
                            $productTypeImg.height = $productTypeImg.height * (1 / size.height);
                        }
                        if (size.width > 1) {
                            $productTypeImg.width = $productTypeImg.width / (1 / size.width);
                        } else {
                            $productTypeImg.width = $productTypeImg.width * (1 / size.width);
                        }
                    } else {
                        if (scaleAvg > 1) {
                            $productTypeImg.height = $productTypeImg.height / scaleAvg;
                            $productTypeImg.width = $productTypeImg.width / scaleAvg;
                        } else if ($quarterImg) {
                            $quarterImg.height = $quarterImg.height * scaleAvg;
                            $quarterImg.width = $quarterImg.width * scaleAvg;
                        }
                    }
                    $sizeText.style.marginTop = '8px';
                }
                $radioEl.htmlFor = uuid;
                $inputEl.id = uuid;
                $inputEl.name = `${Anchorize(type)}-size-radio`;
                $inputEl.value = size.name;
                $inputEl.dataset.width = size.width.toString();
                $inputEl.dataset.height = size.height.toString();
                $inputEl.dataset.sizeID = size.id;
                $sizeText.textContent = size.name;
                $sizesContainer.appendChild($radioEl);
                sizeRadios.push($inputEl);
                const $imgContainer = $radioEl.querySelector('.img-container') as HTMLElement;
                if ($imgContainer && $imgContainer.offsetWidth > 127) {
                    const $scale = 128 / $imgContainer.offsetWidth;
                    $productTypeImg.height = $productTypeImg.height * $scale;
                    $productTypeImg.width = $productTypeImg.width * $scale;
                    if ($quarterImg) {
                        $quarterImg.height = $quarterImg.height * $scale;
                        $quarterImg.width = $quarterImg.width * $scale;
                    }
                }
            }
        }
        RadioBorderListener();
        for (const sizeRadio of sizeRadios) {
            sizeRadio.addEventListener('change', async () => {
                lineItemTypeSize = {
                    id: sizeRadio.dataset.sizeID || '',
                    name: sizeRadio.value,
                    width: parseFloat(sizeRadio.dataset.width || '0'),
                    height: parseFloat(sizeRadio.dataset.height || '0'),
                };
                G().Set('size', sizeRadio.value);
                const preSelectedQty = document.querySelector<HTMLInputElement>('.qty-input:checked')?.value;
                await createQtyEls(lineItem, type, sizeRadio.value, parseFloat(sizeRadio.dataset.width || '0'), parseFloat(sizeRadio.dataset.height || '0'), parseInt(preSelectedQty || '0', 10) || 0, typePage);
            });
        }
        if (G().Get('size')) {
            const $radio = sizeRadios.find($radio => $radio.value === G().Get('size'));
            if ($radio) {
                $radio.checked = true;
                $radio.dispatchEvent(new Event('change'));
            } else {
                sizeRadios[0].checked = true;
                sizeRadios[0].dispatchEvent(new Event('change'));
            }
        } else if (preSelectedSize) {
            for (const sizeRadio of sizeRadios) {
                if (sizeRadio.value === preSelectedSize) {
                    sizeRadio.checked = true;
                    sizeRadio.dispatchEvent(new Event('change'));
                    break;
                }
            }
            if (sizeRadios.length && !sizeRadios.some(sizeRadio => sizeRadio.checked)) {
                sizeRadios[0].checked = true;
                sizeRadios[0].dispatchEvent(new Event('change'));
            }
        } else {
            if (sizeRadios.length) {
                sizeRadios[0].checked = true;
                sizeRadios[0].dispatchEvent(new Event('change'));
            }
        }
    });
}

let customQtyHasListeners: boolean = false;
async function createQtyEls(lineItem: string, type: string, sizeName: string, width: number, height: number, preSelectedQty: number, typePage: string) {
    customQtyHasListeners = false;
    await GetPrices(lineItem, type, width, height, undefined, sizeName).then(async resp => {
        const $qtyRadioContainer = document.querySelector('#qty-radio-container') as HTMLElement;
        $qtyRadioContainer.innerHTML = '';
        const qtyPrices = [];
        for (const qtyPrice of resp) {
            qtyPrices.push(qtyPrice.price.toNumber());
        }
        const basePrice = Math.max(...qtyPrices);
        const lowestQty = Math.min(...resp.map(qtyPrice => qtyPrice.quantity));
        for (const qtyPrice of resp) {
            const $qtyRadioContainerFirstChild = Clone('#qty-radio-template').firstElementChild as HTMLLabelElement;
            const $qtyRadio = $qtyRadioContainerFirstChild.querySelector('input') as HTMLInputElement;
            $qtyRadio.value = qtyPrice.quantity.toString();
            const addlUnitCost = await getAddlUnitCosts(lineItem, type);
            if (addlUnitCost.unitCost.gt(0)) {
                $qtyRadio.dataset.unitPrice = qtyPrice.price.add(addlUnitCost.unitCost).toFixed(2);
            } else {
                $qtyRadio.dataset.unitPrice = qtyPrice.price.toFixed(2);
            }
            const $qtySpan = $qtyRadioContainerFirstChild.querySelector('.quantity') as HTMLElement;
            const $priceSpan = $qtyRadioContainerFirstChild.querySelector('.price-per-unit') as HTMLElement;
            const $saveSpan = $qtyRadioContainerFirstChild.querySelector('.save') as HTMLElement;
            const percentageSavings = ((basePrice - qtyPrice.price.toNumber()) / basePrice) * 100;
            if (percentageSavings > 0) {
                $saveSpan.textContent = `SAVE ${Math.round(percentageSavings)}% `;
            } else {
                $saveSpan.textContent = '';
                const $qtyRadioTextDivider = $qtyRadioContainerFirstChild.querySelector('.qty-radio-text-divider') as HTMLElement;
                $qtyRadioTextDivider.style.visibility = 'hidden';
            }
            $qtySpan.textContent = qtyPrice.quantity.toLocaleString();
            let lineItemStr: string | undefined;
            switch (lineItem) {
            case 'lapel pins':
                lineItemStr = 'pin';
                break;
            case 'patches':
                lineItemStr = 'patch';
                break;
            case 'lanyards':
                lineItemStr = 'lanyard';
                break;
            case 'key chains':
            case 'keychains':
                lineItemStr = 'keychain';
                break;
            case 'challenge coins':
                lineItemStr = 'coin';
                break;
            case 'belt buckles':
                lineItemStr = 'buckle';
                break;
            case 'medals':
                lineItemStr = 'medal';
                break;
            default:
                lineItemStr = 'unit';
                break;
            }
            if (addlUnitCost.unitCost.gt(0)) {
                $priceSpan.textContent = `${DollarFormat(qtyPrice.price.add(addlUnitCost.unitCost).toFixed(2))} per ${lineItemStr ? lineItemStr : lineItem} `;
            } else {
                $priceSpan.textContent = `${DollarFormat(qtyPrice.price.toFixed(2))} per ${lineItemStr ? lineItemStr : lineItem} `;
            }
            $qtyRadioContainer.appendChild($qtyRadioContainerFirstChild);
        }

        const [$customQtyRadio, $customQtyInputContainer] = createCustomRadio();
        const $qtyRadio = $customQtyRadio.querySelector('input') as HTMLInputElement;
        $qtyRadio.addEventListener('change', () => {
            if ($qtyRadio.checked) {
                $customQtyInputContainer?.classList.remove('d-none');
                const $input = $customQtyInputContainer?.querySelector<HTMLInputElement>('input');
                if ($input && G().Get('qty')) {
                    $input.value = G().Get('qty') || '100';
                }

                $qtyRadio.value = $input?.value || '1';
                $customQtyRadio.parentElement?.appendChild($customQtyInputContainer);
                if (!customQtyHasListeners) {
                    ['change', 'input'].forEach(event => $input?.addEventListener(event, () => {
                        if ($input.value) {
                            G().Set('qty', $input.value);
                            $qtyRadio.value = $input.value;
                            void GetPrice(lineItem, type, sizeName || `${width.toString()} "`, parseInt($input.value, 10)).then(resp => {
                                void updatePriceEstimate($input.value, resp.toFixed(2), lineItem, type, sizeName, typePage);
                            });
                        }
                    }));
                    $input?.dispatchEvent(new Event('change'));
                    customQtyHasListeners = true;
                }
            }
        });
        $qtyRadioContainer.appendChild($customQtyRadio);

        const $qtyRadios = Array.from($qtyRadioContainer.querySelectorAll('input'));
        for (const $qtyRadio of $qtyRadios) {
            $qtyRadio.addEventListener('change', () => {
                if (!($qtyRadio.id === 'custom-qty-input')) {
                    $customQtyInputContainer?.classList.add('d-none');
                    void updatePriceEstimate($qtyRadio.value, $qtyRadio.dataset.unitPrice || '0', lineItem, type, sizeName, typePage);
                }
                G().Set('qty', $qtyRadio.value.toString());
            });
        }
        if (G().Get('qty')) {
            const num = parseInt(G().Get('qty') || '', 10);
            if (num < lowestQty) {
                G().Set('qty', lowestQty.toString());
            }
            const $radio = $qtyRadios.find($radio => $radio.value.toString() === G().Get('qty'));
            if ($radio) {
                $radio.checked = true;
                $radio.dispatchEvent(new Event('change'));
            } else if (num > 0) {
                const $customQtyInput = $qtyRadios.find($radio => $radio.id === 'custom-qty-input');
                if ($customQtyInput && $customQtyInputContainer) {
                    $customQtyInput.checked = true;
                    $customQtyInputContainer.classList.remove('d-none');
                    const $qtyInput = $customQtyInputContainer.querySelector<HTMLInputElement>('input');
                    if ($qtyInput) {
                        $qtyInput.value = num.toString();
                    }
                    $customQtyInput.dispatchEvent(new Event('change'));
                }
            } else {
                $qtyRadios[0].checked = true;
                $qtyRadios[0].dispatchEvent(new Event('change'));
            }
        } else if (preSelectedQty) {
            for (const $qtyRadio of $qtyRadios) {
                if (parseInt($qtyRadio.value, 10) === preSelectedQty) {
                    $qtyRadio.checked = true;
                    $qtyRadio.dispatchEvent(new Event('change'));
                    void updatePriceEstimate($qtyRadio.value, $qtyRadio.dataset.unitPrice || '0', lineItem, type, sizeName, typePage);
                    break;
                } else {
                    void updatePriceEstimate($qtyRadios[0].value, $qtyRadios[0].dataset.unitPrice || '0', lineItem, type, sizeName, typePage);
                }
            }
            if (!$qtyRadios.some($qtyRadio => $qtyRadio.checked)) {
                if ($qtyRadios.length > 1) {
                    $qtyRadios[0].checked = true;
                }
            }
        } else {
            $qtyRadios[0].checked = true;
            $qtyRadios[0].dispatchEvent(new Event('change'));
        }
    });
}

function createCustomRadio(): [HTMLElement, HTMLElement] {
    const $customQtyInputContainer = Clone('#custom-qty-input-container').firstElementChild as HTMLElement;
    const $customQtyRadio = Clone('#qty-radio-template').firstElementChild as HTMLElement;
    const $qtyRadio = $customQtyRadio.querySelector('input') as HTMLInputElement;
    $qtyRadio.id = 'custom-qty-input';
    $qtyRadio.dataset.custom = 'true';
    const $qtySpan = $customQtyRadio.querySelector('.quantity') as HTMLElement;
    const $priceSpan = $customQtyRadio.querySelector('.price-per-unit') as HTMLElement;
    $priceSpan.textContent = '';
    const $qtyRadioTextDivider = $customQtyRadio.querySelector('.qty-radio-text-divider') as HTMLElement;
    $qtyRadioTextDivider.style.visibility = 'hidden';
    $qtySpan.textContent = 'Custom';
    CustomQtyBtnInit($customQtyInputContainer);
    return [$customQtyRadio, $customQtyInputContainer];
}

async function updatePriceEstimate(qty: string, unitPrice: string, lineItem: string, type: string, size: string, typePage: string) {
    const $priceEstimateContainer = document.querySelector<HTMLElement>('#price-estimate-container');
    const $priceEstimateInner = $priceEstimateContainer?.querySelector<HTMLElement>('.price-estimate-inner');
    const $lowQtyMsg = $priceEstimateContainer?.querySelector<HTMLElement>('.low-qty');
    const $qty = $priceEstimateInner?.querySelector<HTMLElement>('#qty-amount');
    const $unitPrice = $priceEstimateInner?.querySelector<HTMLElement>('#unit-price-amount');
    const $unitPriceText = $priceEstimateInner?.querySelector<HTMLElement>('#unit-price-text');
    const $estimatedTotal = $priceEstimateInner?.querySelector<HTMLElement>('#estimated-total');
    const $shopAdditionalBtns = document.querySelectorAll<HTMLAnchorElement>('.shop-additional-btn');
    const $priceEstimateSpinner = $priceEstimateContainer?.querySelector<HTMLElement>('#price-estimate-spinner');

    $priceEstimateSpinner?.classList.remove('d-none');

    const $tempItems = $addlRowCostItems;

    $addlRowCostItems = [];

    let addlSetupCosts = Big(0);
    let addlUnitCost = Big(0);
    let addlUnitCostItems: string[] = [];

    await (async () => {
        const t = (await GetTypes(lineItem ?? currProduct)).find(t => t.name === type);
        const moldFee = await GetMoldFee(
            lineItem === 'Keychains' ? 'Key Chains' : lineItem,
            t?.id || '',
            lineItemTypeSize.id || '',
            lineItemTypeSize.width || Big(size).toNumber(),
            lineItemTypeSize.height || Big(size).toNumber(),
            Big(qty).toNumber(),
        );

        if (moldFee.gt(Big(0))) {
            const moldFeeNotice = Clone('#price-estimate-row-template').firstElementChild as HTMLElement;
            const item = moldFeeNotice.querySelector('.row-item') as HTMLElement;
            const price = moldFeeNotice.querySelector('.row-price') as HTMLElement;
            item.textContent = 'Mold Fee';
            price.textContent = DollarFormat(moldFee.toFixed(2));
            addlSetupCosts = addlSetupCosts.add(moldFee);
            $addlRowCostItems.push(moldFeeNotice);
        }

        const { unitCost, items } = await getAddlUnitCosts(lineItem, type).then(resp => resp);
        addlUnitCost = unitCost;
        addlUnitCostItems = items;

        await getAddlSetupCosts(lineItem, type).then(resp => {
            addlSetupCosts = addlSetupCosts.add(resp);
        });

        const $priceEstimateRows = document.querySelector<HTMLElement>('.price-estimate-items');
        for (const $addlRowCostItem of $addlRowCostItems) {
            if ($tempItems.length) {
                $tempItems[0].remove();
            }
            $priceEstimateRows?.appendChild($addlRowCostItem);
        }
        if ($tempItems.length) {
            for (const $tempItem of $tempItems) {
                $tempItem.remove();
            }
        }
    })().finally(() => {
        $priceEstimateSpinner?.classList.add('d-none');
    });

    function toggleLowQtyMsg(show: boolean) {
        if (show) {
            $priceEstimateInner?.classList.add('d-none');
            $lowQtyMsg?.classList.remove('d-none');
        } else {
            $priceEstimateInner?.classList.remove('d-none');
            $lowQtyMsg?.classList.add('d-none');
        }
    }

    if ($qty) {
        $qty.textContent = parseInt(qty, 10).toLocaleString();
    }

    if ($unitPrice && $unitPriceText) {
        if (addlUnitCost.gt(0)) {
            $unitPrice.textContent = DollarFormat(Big(unitPrice).toFixed(2));

            if (addlUnitCostItems.length) {
                const addlUnitCostItemsUnique = Array.from(new Set(addlUnitCostItems));
                let str: string = '';
                if (addlUnitCostItemsUnique.length === 1) {
                    str += addlUnitCostItems[0];
                } else {
                    for (const addUnitCostItem of addlUnitCostItemsUnique) {
                        str += `${addUnitCostItem}, `;
                    }
                }
                $unitPriceText.textContent = `Unit Price (includes ${str} fees)`;
            }
        } else {
            $unitPriceText.textContent = 'Unit Price';
            if (unitPrice === '0.00') {
                toggleLowQtyMsg(true);
            } else {
                toggleLowQtyMsg(false);
                $unitPrice.textContent = DollarFormat(unitPrice);
            }
        }
    }

    if ($estimatedTotal) {
        if (parseFloat(unitPrice)) {
            if (!((parseFloat(qty) * parseFloat(unitPrice)) > 0)) {
                toggleLowQtyMsg(true);
            } else {
                toggleLowQtyMsg(false);
                $estimatedTotal.textContent = DollarFormat(Big(new Big(qty).times(new Big(unitPrice))).add(addlSetupCosts).toFixed(2));
            }
        } else {
            toggleLowQtyMsg(true);
        }
    }

    const capitalizedType = type.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
    const capitalizedLineItem = lineItem.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
    const capitalizedSubType = currSubType.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');

    $shopAdditionalBtns.forEach($shopAdditionalBtn => {
        $shopAdditionalBtn.textContent = `Shop ${capitalizedSubType ? capitalizedSubType : capitalizedType} ${capitalizedLineItem}`;
        $shopAdditionalBtn.href = typePage;
    });
}

function updatePricingChart(lineItem: string, type: string) {
    const $pricingChartContainer = document.querySelector<HTMLElement>('#pricing-table-container');
    const $pricingChartTabPane = document.querySelector<HTMLElement>('#pricing-chart-tab-pane');
    const $pricingChartLineItem = $pricingChartTabPane?.querySelector<HTMLElement>('#pricing-chart-lineitem');
    if ($pricingChartLineItem) {
        $pricingChartLineItem.textContent = lineItem;
    }
    if ($pricingChartContainer) {
        void createPriceChart(lineItem, type, $pricingChartContainer);
    }
}

async function createPriceChart(lineItem: string, type: string, container: HTMLElement) {
    const sizes = await GetSizes(lineItem, type);

    const qtys = new Set<number>();
    for (const size of sizes) {
        if (!size.prices.length) {
            continue;
        }

        for (const price of size.prices) {
            qtys.add(price.quantity);
        }
    }

    let leftPos: string;

    if (qtys.size > 6) {
        leftPos = '-2%';
    } else {
        leftPos = '-3%';
    }

    const $tableContainer = FromString(`<div class="d-flex flex-column" style="margin-left: ${leftPos.replace('-', '')}; min-width: 500px">
                                    <div id="table-title" class="text-center py-4 align-self-end" style="width: 88%; margin-right: 5%; background: #D3DBF3; border-top: 2px solid #B3C1EA; border-left: 2px solid #B3C1EA; border-right: 2px solid #B3C1EA; border-top-left-radius: 1.5rem; border-top-right-radius: 1.5rem;"">
                                        <span class="fw-bold">Quantity</span>
                                    </div>
                                    <div class="d-flex">
                                        <table id="size-table" class="table table-striped pricing-table text-center overflow-hidden d-inline-block w-auto" style="box-shadow: 0px 4px 6px -4px rgba(61, 69, 88, 0.12), 0px 8px 8px -4px rgba(61, 69, 88, 0.08); margin-right: ${leftPos}; z-index: 1;">
                                        <thead>
                                            <tr>
                                                <th scope="col" class="text-nowrap" style="background: #D3DBF3;">Size <span class="fw-normal fst-italic">(in)</span></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                        </tbody>
                                    </table>
                                        <table id="qty-table" class="table table-striped pricing-table text-center overflow-hidden" style="box-shadow: 0px 2px 4px -2px rgba(61, 69, 88, 0.12), 0px 4px 4px -2px rgba(61, 69, 88, 0.08); border-top-left-radius: 0; border-bottom-left-radius: 0;">
                                            <thead>
                                                <tr>
                                                    <th scope="col">Size</th>
                                                    <th scope="col">50</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <th scope="row">1.5"</th>
                                                    <td>$6.03</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>`);

    const $sizeTable = $tableContainer.querySelector('#size-table') as HTMLTableElement;

    const $table = $tableContainer.querySelector('#qty-table') as HTMLTableElement;
    const $thead = $table.querySelector('thead') as HTMLTableSectionElement;
    const $tbody = $table.querySelector('tbody') as HTMLTableSectionElement;

    $thead.innerHTML = '';
    $tbody.innerHTML = '';

    const $sizeTableBody = $sizeTable.querySelector('tbody') as HTMLTableSectionElement;
    $sizeTableBody.innerHTML = '';

    const qtysSorted = Array.from(qtys).sort((a, b) => a - b);

    const pricesBySize = new Map<string, Map<number, Big>>();
    for (const size of sizes) {
        const prices = new Map<number, Big>();
        for (const price of size.prices) {
            prices.set(price.quantity, price.price);
        }
        pricesBySize.set(size.name, prices);
    }

    const $tr = FromString('<tr></tr>');
    $thead.appendChild($tr);

    for (const qty of qtys) {
        $tr.appendChild(FromString(`<th style="background: #E3E9F8;">${Intl.NumberFormat().format(qty)}</th>`));
    }

    for (const [size, prices] of pricesBySize) {
        if (!prices.size) {
            continue;
        }

        const $tr = FromString('<tr></tr>');
        $tbody.appendChild($tr);

        const $sizeTr = FromString(`<tr><th class="fw-normal ps-8 text-nowrap" scope="row">${size.replaceAll('"', '')}</th></tr>`);
        $sizeTableBody.appendChild($sizeTr);

        for (const qty of qtysSorted) {
            const price = prices.get(qty);
            $tr.appendChild(FromString(`<td>${price ? DollarFormat(price) : ''}</td>`));
        }
    }

    const $nonHeadTrs = Array.from($tbody.querySelectorAll('tr'));
    for (const $nonHeadTr of $nonHeadTrs) {
        $nonHeadTr.style.borderBottom = 'none';
        const $nonHeadTh = $nonHeadTr.querySelector('th');
        if ($nonHeadTh) {
            $nonHeadTh.style.borderBottom = 'none';
        }
        for (const $td of Array.from($nonHeadTr.querySelectorAll('td'))) {
            $td.style.borderBottom = 'none';
        }
    }

    container.innerHTML = '';
    container.appendChild($tableContainer);
}

function aboutSection(product: string, type: string, subType?: string) {
    const $aboutSections = Array.from(document.querySelectorAll<HTMLElement>('.about-section'));
    let $section: HTMLElement | undefined;
    if (subType) {
        $section = $aboutSections.find($section => $section.dataset.product === product && $section.dataset.type === subType);
    } else {
        $section = $aboutSections.find($section => $section.dataset.product === product && $section.dataset.type === type);
    }
    if ($section) {
        for (const $aboutSection of $aboutSections) {
            if ($aboutSection !== $section) {
                $aboutSection.classList.add('d-none');
            } else {
                $aboutSection.classList.remove('d-none');
            }
        }
    }
}

function gallerySection(product: string, type: string, subType?: string) {
    const $gallerySections = Array.from(document.querySelectorAll<HTMLElement>('.gallery-section'));

    let $section: HTMLElement | undefined;
    if (subType) {
        $section = $gallerySections.find($section => $section.dataset.product === product && $section.dataset.type === subType);
    } else {
        $section = $gallerySections.find($section => $section.dataset.product === product && $section.dataset.type === type);
    }
    if ($section) {
        const hasGalleryImgs = $section.querySelectorAll('a').length > 1;

        for (const $gallerySection of $gallerySections) {
            if ($gallerySection !== $section || !hasGalleryImgs) {
                $gallerySection.classList.add('d-none');

                const existingGallery = $gallerySection.querySelector('#gallery-images');
                if (existingGallery) {
                    existingGallery.removeAttribute('id');
                }
                $gallerySection.querySelectorAll('a[data-fancybox]').forEach(a => a.removeAttribute('data-fancybox'));
            } else {
                $gallerySection.classList.remove('d-none');
            }
        }

        const $galleryImages = $section.querySelector<HTMLElement>('.row');
        if ($galleryImages) {
            $galleryImages.id = 'gallery-images';

            $galleryImages.querySelectorAll('a').forEach(a => {
                a.setAttribute('data-fancybox', type ?? 'gallery');
            });
            if ($galleryImages.childElementCount > 3) {
                GalleryMasonry = new Masonry($galleryImages, {
                    itemSelector: '.gallery-image-parent:not(.d-none)',
                });
            }
        }
    }
}

async function getAddlSetupCosts(lineItem: string, type: string): Promise<Big> {
    const $addlSetupCosts = Array.from(document.querySelectorAll<HTMLElement>('.additional-one-time-fee'));
    if ($addlSetupCosts.length) {
        const $lineItems = $addlSetupCosts.filter($addlSetupCost => $addlSetupCost.dataset.lineitem === lineItem);
        if ($lineItems.length) {
            const $lineItemTypes = $lineItems.filter($lineItem => $lineItem.dataset.lineitemtype === type);
            if ($lineItemTypes.length) {
                let totalPrice = Big(0);
                for (const $lineItemType of $lineItemTypes) {
                    let price = Big(0);
                    const child = $lineItemType.getAttribute('data-child');
                    const option = $lineItemType.getAttribute('data-option');
                    if (child && !option) {
                        price = await GetChildPrice(lineItem, child);
                    } else if (child && option) {
                        price = await GetOptionPrice(lineItem, child, option);
                    }

                    const $row = Clone('#price-estimate-row-template').firstElementChild as HTMLElement;
                    const item = $row.querySelector('.row-item') as HTMLElement;
                    const priceEl = $row.querySelector('.row-price') as HTMLElement;
                    item.textContent = child ? child : 'Additional Setup Fee';
                    priceEl.textContent = DollarFormat(price.toFixed(2));
                    $addlRowCostItems.push($row);
                    totalPrice = totalPrice.add(price);
                }
                return totalPrice;
            }
        }
    }
    return Big(0);
}

async function getAddlUnitCosts(lineItem: string, type: string): Promise<{ unitCost: Big; items: string[] }> {
    const $addlUnitCosts = Array.from(document.querySelectorAll<HTMLElement>('.additional-unit-costs'));
    if ($addlUnitCosts.length) {
        const $lineItems = $addlUnitCosts.filter($addlUnitCost => $addlUnitCost.dataset.lineitem === lineItem);
        if ($lineItems.length) {
            const $lineItemTypes = $lineItems.filter($lineItem => $lineItem.dataset.lineitemtype === type);
            if ($lineItemTypes.length) {
                let totalPrice = Big(0);
                const children: string[] = [];
                for (const $lineItemType of $lineItemTypes) {
                    if ($lineItemType.dataset.subtype) {
                        const $currTypes = getRadios();
                        const $currType = $currTypes.find($currType => $currType.checked);
                        if ($currType && $currType.dataset.type !== $lineItemType.dataset.subtype) {
                            continue;
                        }
                    }

                    let price = Big(0);
                    const child = $lineItemType.getAttribute('data-child');
                    const option = $lineItemType.getAttribute('data-option');
                    if (child && !option) {
                        price = await GetChildPrice(lineItem, child);
                        children.push(child);
                    } else if (child && option) {
                        price = await GetOptionPrice(lineItem, child, option);
                        children.push(child);
                    }

                    totalPrice = totalPrice.add(price);
                }
                return { unitCost: totalPrice, items: children };
            }
        }
    }
    return { unitCost: Big(0), items: [] };
}